"use client";
import { Link, type LinkProps } from "@ecco/ui/link";
import { Link as LocaleLink } from "@i18n/routing";
import type { ComponentProps } from "react";

type NextIntlLinkProps = ComponentProps<typeof LocaleLink>;

export type NextLinkProps = NextIntlLinkProps &
    LinkProps & {
        locale?: string;
    };

export const NextLink = (props: NextLinkProps) => <Link as={LocaleLink} {...props} />;
